import Vue from 'vue';
import Vuex from 'vuex';

// 启用vuex
Vue.use(Vuex);

// 声明vuex实例对象，创建四个对象属性
export default new Vuex.Store({
  state: {
    reMsg: {},
    api: '/api', //api
    jgName: '',
    url: 'https://crm.jeesit.com',
    registerMsg: '',
    usermsg: JSON.parse(localStorage.getItem('token')) || '', //用户登录信息
    once: JSON.parse(localStorage.getItem('once')) || '', //用户登录信息
  },
  mutations: {},
  actions: {},
  getters: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js